import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ViewModeService } from '@services/view-mode.service';

import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { Logger } from '@utils/logger';

/**
 * Logger
 */
const logger = Logger.getLogger('RichTextComponent');

/**
 * Interface for the RichText Content
 */
interface RichTextContent {
  content: RichTextValue;
}

interface RichTextValue {
  value: string;
}

/**
 * FT Rich Text component
 *
 * This component is used at the top of a template and has it's own associated document type.
 *
 * Selector: `ft-rich-text`
 *
 * Exported as: `RichTextComponent`
 */
@Component({
  selector: 'ft-rich-text',
  templateUrl: './rich-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RichTextComponent extends AbstractBaseComponent implements OnInit {
  /**
   * Url of Image ref
   */
  imageUrl: string;

  /**
   * Constructor
   */
  constructor(private viewModeService: ViewModeService) {
    super();
    this.isEditMode = this.viewModeService.isEditMode();
  }

  /**
   * Angular init hook
   */
  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Get content from document
   */
  get content() {
    const content = this.document?.getData<RichTextContent>();
    if (content?.content?.value) {
      // Transform footnote links to include scroll functionality
      const transformedValue = this.transformFootnoteLinks(
        content.content.value
      );
      return {
        ...content,
        content: {
          ...content.content,
          value: transformedValue,
        },
      };
    }
    return content;
  }

  /**
   * Transform footnote links to include scroll back functionality for performance list caveats
   */
  private transformFootnoteLinks(html: string): string {
    // Match footnote links with pattern: <a id="fn{number}" class="strategy-data__footnotes-src...">number</a>
    return html.replace(
      /<a\s+id="fn(\d+)"\s+class="([^"]*strategy-data__footnotes-src[^"]*)">(\d+)<\/a>/g,
      (match, footnoteNumber, classNames, displayNumber) => {
        return `<a href="javascript:void(0)" onclick="document.getElementById('fnref${footnoteNumber}')?.scrollIntoView({ behavior: 'smooth', block: 'center' })" id="fn${footnoteNumber}" class="${classNames}">${displayNumber}</a>`;
      }
    );
  }
}
